import __request__ from "routing/request";
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/users", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listUsers(include_permissions = true, include_sessions = true, requestOptions) {
  return __request__("GET", "/users", null, { "include_permissions": include_permissions, "include_sessions": include_sessions }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getBasicUserById(userId, requestOptions) {
  return __request__("GET", `/users/basic/id/${userId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getbyId(userId, requestOptions) {
  return __request__("GET", `/users/id/${userId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteUserById(userId, requestOptions) {
  return __request__("DELETE", `/users/id/${userId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "full_name", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/users/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function checkUsernameAvailability(username, requestOptions) {
  return __request__("GET", "/users/username_availability", null, { "username": username }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function changeUser(userId, JSONbody, requestOptions) {
  return __request__("PUT", `/users/${userId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function changePassword(userId, JSONbody, requestOptions) {
  return __request__("PUT", `/users/${userId}/password`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateAccountStatus(userId, newStatus, requestOptions) {
  return __request__("PUT", `/users/${userId}/status/${newStatus}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listTokens(userId, requestOptions) {
  return __request__("GET", `/users/${userId}/tokens`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function revokeToken(userId, idOrToken, requestOptions) {
  return __request__("DELETE", `/users/${userId}/tokens/${idOrToken}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function generateNewToken(userId, name, JSONbody, requestOptions) {
  return __request__("POST", `/users/${userId}/tokens/${name}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(username, requestOptions) {
  return __request__("GET", `/users/${username}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteUser(username, requestOptions) {
  return __request__("DELETE", `/users/${username}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function editPermissions(username, JSONbody, requestOptions) {
  return __request__("PUT", `/users/${username}/permissions`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deletePermissions(username, requestOptions) {
  return __request__("DELETE", `/users/${username}/permissions`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function savePreferences(username, JSONbody, requestOptions) {
  return __request__("PUT", `/users/${username}/preferences`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
